// global-object.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { loadOtherClasses, setTermObject } from './class.actions';
import { loadBulkTeachingClasses } from './class.actions';

export interface PeriodState {
  period: string | number | null;
  prev_period: string | number | null;
  className: string;
  isMasked: number;
}

export interface otherClasses {
  class_id: number;
  standard: string;
  division: string;
  class_teacher_id: number;
  teacher_name: string;
  class_total: number;
  is_active: number;
  assessment_period_id: number | null;
  previous_assessment_period_id: number | null;
  previous_period_name: string;
  previous_end_date: string | Date | null;
  previous_start_date: string | Date | null;
  period_name: string | null;
  end_date: string | Date | null;
  start_date: string | Date | null;
}

export interface OtherClassesState {
  classes: otherClasses[];
  
}

export interface BulkTeachingClassesState {
  classes: otherClasses[]; // reuse same interface
}

export const initialBulkTeachingClassesState: BulkTeachingClassesState = {
  classes: [],
};



export const initialState: PeriodState = {
  period: null,
  prev_period: null,
  className: 'class',
  isMasked: 0,
};

export const periodReducer = createReducer(
  initialState,
  on(setTermObject, (state, payload) => ({
    ...state,
    ...payload,
  }))
);

export const initialOtherClassesState: OtherClassesState = {
  classes: [],
};

export const otherClassesReducer = createReducer(
  initialOtherClassesState,
  on(loadOtherClasses, (state, { data }) => ({
    ...state,
    classes: data,
  }))
);

export const bulkTeachingClassesReducer = createReducer(
  initialBulkTeachingClassesState,
  on(loadBulkTeachingClasses, (state, { data }) => ({
    ...state,
    classes: data,
  }))
);
